import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card';
import Breadcrumb from '@components/Shared/Breadcrumb';
import AddEquipments from './AddEquipments';
import EditEquipments from './EditEquipments';
import ModalComponent from '@components/Modal/ModalComponent';
import useGetEquipmentsList from '@hooks/FLeet/useGetEquipmentsList';
import Loading from '@components/Shared/Loader/Loading';
import Button from 'react-bootstrap/Button';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { Form, Row, Col, Badge } from 'react-bootstrap';
import Pagination from '@components/Shared/Pagination/Pagination';
import styles from './VehicleCard.module.css'; // استيراد CSS Module

const VehicleCard = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const [id, setId] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(8);

  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();

  const { EquipmentsList, loading, error } = useGetEquipmentsList();

  // Filter equipment based on search and status
  const filteredEquipments = EquipmentsList?.filter(equipment => {
    const matchesSearch =
      equipment.plateNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      equipment.modelName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      equipment.peopleNumber ?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      equipment.modelName2?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus = statusFilter === 'all' || equipment.status === statusFilter;

    return matchesSearch && matchesStatus;
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredEquipments?.slice(indexOfFirstData, indexOfLastData);

  return (
    <>
      <div className={styles.container}>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Vehicles',
              link: null
            }
          ]}
          PageName='Vehicles'
        />

        <div className='ms-auto d-flex align-items-center'>
          <Button
            hidden={!HasPermission('FleetAddEquipment')}
            variant='theme'
            onClick={() => setShow(true)}
            data-bs-toggle='modal'
            data-bs-target='#modalِAddEquipments'
          >
            <i className='bi bi-plus-circle me-1'></i>
            {t('AddVehicle')}
          </Button>
        </div>
      </div>

      {/* Search and Filter Section */}
      <Card className='mb-4'>
        <CardBody>
          <Row>
            <Col md={8}>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fa fa-search text-theme me-2'></i>
                  {t('Search')}
                </span>
                <input
                  type='search'
                  autoComplete='off'
                  className='form-control'
                  placeholder={t('Search')}
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
            </Col>

            <Col md={4}>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='bi bi-funnel'></i>
                </span>
                <Form.Select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                  <option value='all'>{t('All')}</option>
                  <option value='Active'>{t('isActive')}</option>
                  <option value='Inactive'>{t('InActive')}</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Loading loading={loading} error={error}>
        <CardBody>
          <Row>
            {currentData?.map(item => (
              <Col md={6} lg={4} xl={3} key={item.id} className='mb-4'>
                <Card className={`h-100 ${styles.vehicleCard}`}>
                  <div className={styles.vehicleImageContainer}>
                    {item?.image?.filePath ? (
                      <img alt={item.plateNo} className={styles.vehicleImage} src={item.image.filePath} />
                    ) : null}

                    <div
                      className={`${styles.vehicleImagePlaceholder} ${
                        item?.image?.filePath ? styles.dNone : styles.dFlex
                      }`}
                    >
                      <i className='bi bi-car-front-fill text-theme'></i>
                    </div>

                    {/* <Badge
                      bg={item.status === 'Active' ? 'success' : item.status === 'Inactive' ? 'warning' : 'secondary'}
                      className={styles.vehicleStatusBadge}
                    >
                      <i
                        className={`bi ${
                          item.status === 'Active'
                            ? 'bi-check-circle-fill'
                            : item.status === 'Inactive'
                            ? 'bi-exclamation-triangle-fill'
                            : 'bi-question-circle-fill'
                        } me-1`}
                      ></i>
                      {item.status === 'Active'
                        ? t('isActive')
                        : item.status === 'Inactive'
                        ? t('InActive')
                        : t('Unknown')}
                    </Badge> */}
                  </div>
                  <CardBody>
                    <div className='d-flex justify-content-between align-items-start mb-2'>
                      <h6 className={`${styles.vehiclePlate} mb-0`}>
                        <i className='fa-lg bi bi-upc-scan me-2 text-theme'></i>
                        {item.plateNo}
                      </h6>
                    </div>
                    <p className={styles.vehicleModel}>
                      <i className='bi bi-tag me-2 '></i>
                      {i18n.language === 'en' ? item.modelName : item.modelName2}
                    </p>

                    {/* <div className='d-flex justify-content-between align-items-center mb-3'>
                      <small className='text-muted'>
                        {item.peopleName2 ? (
                          <>
                            <span>
                              <i className='bi bi-person-badge me-1'></i>
                              {t('Driver')}: {item.peopleName2}
                            </span>
                            <br />
                            <span>
                              <i className='bi bi-person-badge me-1'></i>
                              {item.peopleNumber}
                            </span>
                          </>
                        ) : (
                          <Badge bg='secondary'>
                            <i className='bi bi-clock-history me-1'></i>
                            {t('Stand By')}
                          </Badge>
                        )}
                      </small>
                    </div> */}

                    <div className='d-flex justify-content-between align-items-center mb-3'>
                      <small className='text-muted'>
                        {item.peopleName2 ? (
                          // حالة: يوجد سائق
                          <>
                            <span>
                              <i className='bi bi-person-badge me-1'></i>
                              {t('Driver')}: {item.peopleName2}
                            </span>
                            <br />
                            <span>
                              <i className='bi bi-123 me-1'></i>
                              {item.peopleNumber}
                            </span>
                          </>
                        ) : item.status === 'Active' ? (
                          // حالة: لا يوجد سائق ولكن المركبة نشطة
                          <Badge bg='secondary'>
                            <i className='bi bi-clock-history me-1'></i>
                            {t('Stand By')}
                          </Badge>
                        ) : (
                          // حالة: لا يوجد سائق والمركبة غير نشطة
                          <Badge bg='warning'>
                            <i className='bi bi-pause-circle me-1'></i>
                            {t('InActive')}
                          </Badge>
                        )}
                      </small>
                    </div>
                    <div className='d-grid gap-2'>
                      <div className='dropdown'>
                        <button
                          className='btn btn-sm btn-outline-theme dropdown-toggle w-100'
                          type='button'
                          data-bs-toggle='dropdown'
                          aria-expanded='false'
                        >
                          <i className='fas fa-cog me-2'></i>
                          {t('Actions')}
                        </button>

                        <ul className='dropdown-menu dropdown-menu-start w-100 '>
                          {HasPermission('FleetViewEquipmentDetails') && (
                            <li>
                              <Link
                                to={''}
                                className='dropdown-item  d-flex justify-content-start '
                                data-bs-toggle='modal'
                                onClick={() => setId(item.id)}
                                data-bs-target='#modalEditEquipments'
                              >
                                <i className='fa fa-info-circle fa-fw me-2 text-theme'></i>
                                {t('ViewDetails')}
                              </Link>
                            </li>
                          )}

                          <li>
                            <Link
                              to={``}
                              className='dropdown-item  d-flex justify-content-start '
                              onClick={() => {
                                Navigate(`${item.id}/ExtraRecordEquipments`);
                                localStorage.setItem('ReferenceName', JSON.stringify(item));
                              }}
                            >
                              <i className='fa-lg fa-fw bi bi-info-circle-fill me-2 text-theme'></i>
                              {t('ExtraInformation')}
                            </Link>
                          </li>

                          {HasPermission('FleetVehicleHistory') && (
                            <li>
                              <Link
                                to={``}
                                className='dropdown-item  d-flex justify-content-start '
                                title='VehicleLogs'
                                onClick={() => {
                                  Navigate(`${item.id}/EquipmentsAssignation`);
                                  localStorage.setItem('ReferenceName', JSON.stringify(item));
                                }}
                              >
                                <i className='fa-lg bi bi-journal-text me-2 text-theme'></i>
                                {t('VehicleLogs')}
                              </Link>
                            </li>
                          )}

                          {HasPermission('FleetViewEquipmentOdometerList') && (
                            <li>
                              <Link
                                to={``}
                                className='dropdown-item  d-flex justify-content-start '
                                onClick={() => {
                                  Navigate(`${item.id}/EquipmentsOdometer`);
                                  localStorage.setItem('ReferenceName', JSON.stringify(item));
                                }}
                                data-toggle='tooltip'
                                title='Odometer'
                              >
                                <i className='fa-lg fa-fw bi bi-speedometer me-2 text-theme'></i>
                                {t('Odometer')}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}

            {filteredEquipments?.length === 0 && !loading && (
              <Col className='text-center py-5'>
                <i className='bi bi-car-front' style={{ fontSize: '3rem', color: '#6c757d' }}></i>
                <p className='mt-3 text-muted'>{t('NoVehiclesFound')}</p>
              </Col>
            )}
          </Row>
          <Pagination
            filteredData={filteredEquipments}
            dataPerPage={dataPerPage}
            handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
            currentPage={currentPage}
          />
        </CardBody>
      </Loading>

      <ModalComponent title={t('AddVehicle')} id='modalِAddEquipments'>
        {Show && <AddEquipments />}
      </ModalComponent>
      <ModalComponent title={t('Edit')} id='modalEditEquipments'>
        {id && <EditEquipments Id={id} />}
      </ModalComponent>
    </>
  );
};

export default VehicleCard;
